import { createAction, props } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

export interface GoPayload {
  path: any[] | string;
  query?: object;
  extras?: NavigationExtras;
}

export const goAction = createAction('[Router] Go', props<GoPayload>());
export const backAction = createAction('[Router] Back');
export const forwardAction = createAction('[Router] Forward');

// @ts-ignore
goAction.logPayload = true;
// @ts-ignore
backAction.logPayload = true;
// @ts-ignore
forwardAction.logPayload = true;
